<template>
  <div class="row">
    <div class="col-12 mb-4">
      <div class="card shadow-sm border-1">
        <div class="card-body d-flex justify-content-between">
          <div class="d-flex align-items-center border-right pr-5">
            <div class="mr-3">
              <span class="text-warning"
                ><i class="fa fa-calendar-day fa-2x"></i
              ></span>
            </div>
            <div>
              <span class="text-muted"
                >Contas a cobrar Hoje

                <i
                  @click="handleHide('sumCollectToday')"
                  :class="[
                    'px-2 text-info fas',
                    show.sumCollectToday ? 'fa-eye-slash' : 'fa-eye',
                  ]"
                />
              </span>
              <h5 class="font-weight-bold">
                <span v-if="show.sumCollectToday">**,**</span>

                <span v-if="!show.sumCollectToday">
                  {{ getSumCollectToday() | decimal }}
                </span>
              </h5>
            </div>
          </div>

          <div class="d-flex align-items-center border-right pr-5">
            <div class="mr-3">
              <span class="text-danger ml-2"
                ><i class="fa fa-calendar-day fa-2x"></i
              ></span>
            </div>
            <div>
              <span class="text-muted">
                Contas Vencidas

                <i
                  @click="handleHide('sumOverDue')"
                  :class="[
                    'px-2 text-info fas',
                    show.sumOverDue ? 'fa-eye-slash' : 'fa-eye',
                  ]"
                />
              </span>
              <h5 class="font-weight-bold">
                <span v-if="show.sumOverDue">**,**</span>

                <span v-if="!show.sumOverDue">
                  {{ getSumOverDue() | decimal }}
                </span>
              </h5>
            </div>
          </div>

          <div class="d-flex align-items-center border-right pr-5">
            <div class="mr-3">
              <span class="text-primary ml-2"
                ><i class="fa fa-calendar-day fa-2x"></i
              ></span>
            </div>
            <div>
              <span class="text-muted">
                Contas a receber
                <i
                  @click="handleHide('sumBillreceivebleTotal')"
                  :class="[
                    'px-2 text-info fas',
                    show.sumBillreceivebleTotal ? 'fa-eye-slash' : 'fa-eye',
                  ]"
                />
              </span>
              <h5 class="font-weight-bold">
                <span v-if="show.sumBillreceivebleTotal">**,**</span>

                <span v-if="!show.sumBillreceivebleTotal">
                  {{ getSumBillreceivebleTotal() | decimal }}
                </span>
              </h5>
            </div>
          </div>
          <div class="d-flex align-items-center border-right pr-5">
            <div class="mr-3">
              <span class="text-primary ml-2"
                ><i class="fa fa-percentage fa-2x"></i
              ></span>
            </div>
            <div>
              <span class="text-muted"
                >Inadimplência
                <i
                  @click="handleHide('sumDefaultRate')"
                  :class="[
                    'px-2 text-info fas',
                    show.sumDefaultRate ? 'fa-eye-slash' : 'fa-eye',
                  ]"
                />
              </span>
              <h5 class="font-weight-bold">
                <span v-if="show.sumDefaultRate"> % **,** </span>
                <span v-if="!show.sumDefaultRate">
                  $ {{ getDefaultRate() | decimal }}
                </span>
              </h5>
            </div>
          </div>

          <div class="d-flex align-items-center pr-5">
            <div class="mr-3">
              <span class="text-danger ml-2"
                ><i class="fa fa-ban fa-2x"></i
              ></span>
            </div>
            <div>
              <span class="text-muted">
                Canceladas

                <i
                  @click="handleHide('sumCanceled')"
                  :class="[
                    'px-2 text-info fas',
                    show.sumCanceled ? 'fa-eye-slash' : 'fa-eye',
                  ]"
                />
              </span>
              <h5 class="font-weight-bold">
                <span v-if="show.sumCanceled"> **,** </span>
                <span v-if="!show.sumCanceled">
                  {{ getSumCanceled() | decimal }}
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: {
        sumCollectToday: false,
        sumOverDue: false,
        sumBillreceivebleTotal: false,
        sumDefaultRate: false,
        sumCanceled: false,
      },
    };
  },

  created() {
    this.show = JSON.parse(localStorage.getItem("show")) || this.show;
  },

  methods: {
    getSumCollectToday() {
      return this.$store.getters["billreceiveble/getSumCollectToday"];
    },

    getSumOverDue() {
      return this.$store.getters["billreceiveble/getsumOverDue"];
    },

    getSumBillreceivebleTotal() {
      return this.$store.getters["billreceiveble/getSumBillreceivebleTotal"];
    },

    getDefaultRate() {
      return this.$store.getters["billreceiveble/getDefaultRate"];
    },

    getSumCanceled() {
      return this.$store.getters["billreceiveble/getsumCanceled"];
    },
    handleHide(card) {
      this.show[card] = !this.show[card];

      localStorage.setItem("show", JSON.stringify(this.show));
    },
  },
};
</script>

<style lang="scss">
.callout {
  border: 0px solid #eee;
  border-right-width: 1px;
  border-radius: 0px;
  margin-right: 8px;
  margin-left: 8px;
  h5 {
    margin-top: 0;
    margin-bottom: 8px;
    margin-right: 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  code {
    border-radius: 3px;
  }
  & + .bs-callout {
    margin-top: -5px;
  }
}
@each $name, $color in (default, rgba(155, 153, 153, 0.267)), (primary, #428bca),
  (success, #5cb85c), (danger, #d9534f), (primary, #f0ad4e), (info, #5bc0de),
  (bdc, #29527a)
{
  .callout-#{$name} {
    border-right-color: $color;
    h5 {
      color: $color;
    }
  }
}
</style>